type HttpError = {
	response: {
		data: {
			message: string;
		};
	};
};

export const isHttpErrorType = (error: unknown): error is HttpError => {
	return typeof error === 'object' && error !== null && 'response' in error;
};

const DEFAULT_ERROR_MESSAGE = 'An unknown error occurred';

export const parseErrorMessage = (error: unknown, defaultMessage = DEFAULT_ERROR_MESSAGE): string =>
	isHttpErrorType(error) ? error.response?.data?.message || defaultMessage : defaultMessage;
